export class FlowModuleEvents {
	public static readonly WON_BIG_WIN: string = 'FlowModuleEvents::__WON_BIG_WIN__';
	public static readonly WON: string = 'FlowModuleEvents::__WON__';
	public static readonly NO_WIN: string = 'FlowModuleEvents::__NO_WIN__';

	public static readonly BONUS_GAME_WON: string = 'FlowModuleEvents::__BONUS_GAME_WON__';
	public static readonly BONUS_GAME_START: string = 'FlowModuleEvents::__BONUS_GAME_START__';
	public static readonly BONUS_GAME_END: string = 'FlowModuleEvents::__BONUS_GAME_END__';
	public static readonly BONUS_GAME_RESTORED: string = 'FlowModuleEvents::__BONUS_GAME_RESTORED__';

	public static readonly FREESPINS_WIN: string = 'FlowModuleEvents::__FREESPINS_WIN__';
	public static readonly FREESPINS_RETRIGGER_WIN: string = 'FlowModuleEvents::__FREESPINS_RETRIGGER_WIN__';
	public static readonly FREE_SPINS_FINISHED: string = 'FlowModuleEvents::__FREE_SPINS_FINISHED__';

	public static readonly AVALANCHE_WON: string = 'FlowModuleEvents::__AVALANCHE_WON__';
	public static readonly RESPIN_WON: string = 'FlowModuleEvents::__RESPIN_WON__';
	public static readonly SCATTER_AND_AVALANCHE_WON: string = 'SCATTER_AND_AVALANCHE_WON';

	public static readonly START_INDIVIDUAL_WIN: string = 'FlowModuleEvents::__START_INDIVIDUAL_WIN__';

	public static readonly CAN_SPIN: string = 'FlowModuleEvents::__CAN_SPIN__';

	public static readonly CAN_CONTINUE_SPIN: string = 'FlowModuleEvents::__CAN_CONTINUE_SPIN__';

	public static readonly CAN_DROP_NEW: string = 'FlowModuleEvents::CAN_DROP_NEW';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/flow/FlowModuleEvents.ts